export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/starIcon.196e25c7.svg","height":17,"width":18,"blurWidth":0,"blurHeight":0};